import { ActivityPopupMeta } from "../types";
import {
  FactorActivity,
  FactorActivityAction,
  FactorActivityData,
} from "./types";
import Container, { EmptyContainer } from "../../meta-container";
import { FactorReceiveActivityPopup } from "./factor-receive-activity";
import { FactorUpdateActivityPopup } from "./factor-update-activity";
import { FactorDeleteActivityPopup } from "./factor-delete-activity";
import { FactorSpendActivityPopup } from "./factor-spend-activity";
import { BackContainer } from "../../../types";

const FactorActivityPopupRenderer = <T extends {}>(
  props: ActivityPopupMeta<T>
) => {
  const activity = props.data as FactorActivity;
  return (
    <Container<FactorActivityAction, BackContainer<FactorActivityData, T>>
      data={{ data: activity.data, back: props.back }}
      type={activity.action}
      match={{
        [FactorActivityAction.None]: EmptyContainer,
        [FactorActivityAction.Receive]: FactorReceiveActivityPopup,
        [FactorActivityAction.Update]: FactorUpdateActivityPopup,
        [FactorActivityAction.Delete]: FactorDeleteActivityPopup,
        [FactorActivityAction.Spend]: FactorSpendActivityPopup,
      }}
    />
  );
};

export default FactorActivityPopupRenderer;
